import { Stack, useTheme } from '@mui/material';
import SliderContent from '@/components/SliderContent';
import Paper from '@/components/Paper';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import Image from 'next/image';
import { FC } from 'react';
import suspiciousData from '../../../../public/json/suspiciousCrypto.json';
import { SuspiciousCoinT } from '../types';

const SuspiciousData: SuspiciousCoinT = suspiciousData;

const SuspiciousCrypto: FC = () => {
  const theme = useTheme();
  const { matches } = useResponsive();
  const WrapperCards = matches({ xs: SliderContent, lg: Stack });

  return (
    <Stack
      gap={{ xs: 8.5, lg: 9 }}
      sx={{
        pb: matches({ lg: 30, xs: 9 }),
        pt: matches({ lg: 2.5, xs: 0 }),
        '&::-webkit-scrollbar !important': {
          display: 'none'
        },
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }}
    >
      <Stack gap={2} mx={4}>
        <Typography
          variant={matches({ lg: 'h6', xs: 'body1' })}
          textAlign={matches({ xs: 'center', lg: 'inherit' })}
          weight="bold"
          color={theme.palette.textColor.A80}
          component="p"
        >
          مراقب این ارزهای دیجیتال باشید …
        </Typography>
        <Typography
          textAlign={matches({ xs: 'center', lg: 'inherit' })}
          color={theme.palette.textColor.A60}
          variant={matches({ xs: 'body3', lg: 'body2' })}
        >
          درباره ارزهای اسکم نیاز هست توضیحات مختصری رو در این قسمت گفته باشیم.
        </Typography>
      </Stack>
      <WrapperCards
        {...matches({
          xs: {
            uniqueId: 'scam',
            itemsProps: {
              sx: {
                mx: 1,
                width: '54.47%',
                '&:first-child': { marginLeft: 4 },
                '&:last-child': { marginRight: 4 }
              }
            },
            autoplay: false
          },
          lg: {
            direction: 'row',
            spacing: 4
          }
        })}
      >
        {SuspiciousData.map((item, index) => (
          <Paper
            key={index}
            elevation={14}
            sx={{
              display: 'flex',
              flex: 1,
              justifyContent: 'stretch',
              my: matches({ xs: 1, lg: 0 })
            }}
          >
            <a
              href={item.link}
              target="_blank"
              style={{
                width: '100%',
                height: '100%',
                padding: 24,
                cursor: 'pointer',
                textDecoration: 'none',
                marginBottom: matches({ xs: 1, lg: 0 })
              }}
            >
              <Stack spacing={3} justifyContent="center" alignItems="center">
                <Image src={item.symbol} alt="" width={40} height={40} />

                <Typography
                  variant="body1"
                  weight="bold"
                  textAlign="center"
                  color={theme.palette.textColor.A80}
                >
                  {item.name_fa}
                </Typography>
                <Typography
                  component="div"
                  variant="body3"
                  dangerouslySetInnerHTML={{
                    __html: item.name_en || ''
                  }}
                />
              </Stack>
            </a>
          </Paper>
        ))}
      </WrapperCards>
    </Stack>
  );
};

export default SuspiciousCrypto;
